export const EXTERNAL_SYSTEMS = {
    VIDEO_CMS: 'Video CMS',
    ASSETS: 'Assets',
    BRIXWIRE: 'BrixWire',
    WOODWING_STUDIO: 'WoodWing Studio',
    OKTA: 'Okta',
    KORDIAM: 'Kordiam',
    TOOLBOX: 'Toolbox',
};
